import {css} from 'lit';
export const styles = css`:host {
  --button-text: var(--link-text);
  --button-bg: var(--contrast-light);
  --button-border: none;
  --trigger-height: 50px;
  --trigger-padding: 0;
  --trigger-border-radius: 0;
  --trigger-border: none;
  --trigger-bg: transparent;
  --trigger-color: var(--text-primary);
  --trigger-font-size: 20px;
  --trigger-badge-font-size: 12px;
  --trigger-badge-bg: var(--danger);
  --trigger-badge-margin: 0 0 0 -6px;
}

[slot='trigger'] {
  display: flex;
  align-items: center;
  height: var(--trigger-height);
  padding: var(--trigger-padding);
  color: var(--trigger-color);
  border: var(--trigger-border);
  border-radius: var(--trigger-border-radius);
  background-color: var(--trigger-bg);
  transition: all var(--transition-timing), var(--transition-duration);
}

[slot='trigger'] ef-icon {
    font-size: var(--trigger-font-size);
  }

[slot='trigger'] ef-badge {
    margin: var(--trigger-badge-margin);
    background-color: var(--trigger-badge-bg);
    font-size: var(--trigger-badge-font-size);
    z-index: 1;
  }

@media (hover: hover) {
    [slot='trigger']:hover {
      background-color: var(--trigger-bg-hover);
      color: var(--trigger-color-hover);
    }
  }

[slot='trigger']:active {
    background-color: var(--trigger-bg-active);
    color: var(--trigger-color-active);
  }

ef-dropdown[open] .icon-btn {
    background-color: var(--trigger-bg-hover);
    color: var(--trigger-color-hover);
  }

header,
footer {
  display: flex;
  padding: 8px 16px;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid var(--border-light);
  border-bottom: 1px solid var(--border-light);
}

footer {
  justify-content: center;
}

slot[name='create'] {
  display: block;
  margin-left: auto;
}

.btn-link {
  padding: 4px 8px;
  border: var(--button-border);
  border-radius: var(--border-radius);
  background-color: var(--button-bg);
  color: var(--button-text);
  transition: -webkit-filter var(--transition-timing) var(--transition-duration);
  transition: filter var(--transition-timing) var(--transition-duration);
  transition: filter var(--transition-timing) var(--transition-duration), -webkit-filter var(--transition-timing) var(--transition-duration);
}

@media (hover: hover) {
    .btn-link:hover {
      -webkit-filter: contrast(0.7);
              filter: contrast(0.7);
    }
  }

.btn-link:active {
    -webkit-filter: contrast(0.5);
            filter: contrast(0.5);
  }

.btn-link ef-icon-block {
    color: inherit;
  }

.toggle-muted-btn {
  width: 100%;
  padding: 8px;
  border-left: none;
  border-right: none;
  border-top: var(--button-border);
  border-bottom: var(--button-border);
  border-radius: 0;
  font-size: var(--font-size-sm);
}

.toggle-muted-btn ef-icon-block {
    justify-content: center;
  }

ef-chat-list {
  --chat-list-virtualizer-height: 400px;

  min-height: 200px;
  width: 400px;
}
`;
export default styles;
